import { noop } from "lodash-es";
import { createContext, use } from "react";

export const useMenu = () => use(MenuContext);

export const MenuContext = createContext<{
  parent: HTMLDivElement | null;
  isMenuOpen: boolean;
  isLastOpened: boolean;
  toggleMenu: () => void;
  closeMenu: () => void;
  isTooltipHidden: boolean;
  setIsTooltipHidden: React.Dispatch<boolean>;
}>({
  parent: null,
  isMenuOpen: false,
  isLastOpened: false,
  toggleMenu: noop,
  closeMenu: noop,
  isTooltipHidden: false,
  setIsTooltipHidden: noop,
});
